import { render } from "./ChristmasTheme.vue?vue&type=template&id=06b84a7d&scoped=true"
import script from "./ChristmasTheme.vue?vue&type=script&lang=js"
export * from "./ChristmasTheme.vue?vue&type=script&lang=js"

import "./ChristmasTheme.vue?vue&type=style&index=0&id=06b84a7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b84a7d"]])

export default __exports__